<!-- 登录页 -->
<template>
  <div class="container ignore login" ref="container">
    模拟登录页 url中需要传入token
  </div>
</template>

<script>
import { postImgUpload } from "@/api/upload";
import { Toast, Dialog } from "vant";
import { getUserInfo } from "@/api/user";
import { setToken } from "@/utils/auth";
import {
  setStore,
  getStore,
  removeStore,
  getSessionStore,
  removeSessionStore,
  isWechatBroswer,
} from "@/utils/mUtils";
export default {
  name: "loginInfo",
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      showPop: false,
      countDown: 0,
      intervalId: null,
      isNotWX: false,
      code: "",
      file: null,
      option: {
        info: true,
        autoCropWidth: 180,
        autoCropHeight: 180,
        confirmButtonBackgroundColor: "#6A83FD",
        outputType: "png",
        outputSize: 1,
        enlarge: 1,
      },
      firstCome: false,
      showInput: false,
      checked: true,
      username: "",
      showPreview: true,
      fileList: [],
      point: {
        lv: 10000,
        current: 2860,
        oldCurrent: 0,
      },
      tags: [],
      chooseTags: [],
      fileShow: false,
      registerType: "",
      count: 0,
      isLoading: false,
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    // point:{
    //   handler(newValue, oldValue) {
    //     this.point.oldValue =
    //   },
    //   deep:true
    //   }
    // activeName(newValue, oldValue) {
    //   if (newValue != oldValue) {
    //     console.log(newValue);
    //     switch (newValue) {
    //       case "0":
    //         setStore("orderListType", "0");
    //         break;
    //       case "1":
    //         setStore("orderListType", "1");
    //         break;
    //     }
    //   }
    // },
  },
  // 方法集合
  methods: {
    async upload(file) {
      this.file.status = "uploading";
      this.file.message = "上传中...";
      this.file.file = file;
      const formData = new FormData();
      formData.append("img_upload", file); // 要提交给后台的文件
      await postImgUpload(formData)
        .then((res) => {
          this.userInfo.avatar = res.data;
          this.file.status = "done";
          console.log("完成");
          setStore("userInfo", JSON.stringify(this.userInfo));
        })
        .catch((err) => {
          this.file.status = "failed";
          this.file.message = "上传失败";
        });
    },
    async getUserInfoFunc() {
      this.userInfo = JSON.parse(getStore("userInfo"));

      const res = await getUserInfo();

      this.userInfo = res.data;

      if (!this.userInfo.nickname) {
        this.userInfo.nickname = this.userInfo.username;
      }
      setStore("userInfo", JSON.stringify(this.userInfo));
      this.isFirstCome(this.userInfo.isChoose);
      console.log("获取到了userInfo");
    },
    redirectFunc() {
      this.$router.replace("/home");
    },
  },
  created() {
    console.log("created", "临时的登录页,可以不要");
    // 判断是否是微信环境
    // if (isWechatBroswer()) {
    //   this.isNotWX = false;
    // } else {
    //   this.isNotWX = true;
    //   this.$router.push("/noAuth/notWx"); // 非微信环境 开发环境
    // }
    // 记录需要跳转的路径
    // 判断是否有token 测试用
    if (this.$route.query.token) {
      let token = this.$route.query.token;
      setToken("Bearer " + token);
      this.redirectFunc();
    }
    if (getStore("token")) {
      this.redirectFunc();
    } else {
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
// @import url(); 引入公共css类
@import "~@/styles/variable.scss";
.container.ignore {
  top: 0;
}
</style>
<style lang="scss"></style>
